import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IMultiSelectSettings, IMultiSelectTexts, IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { addListener } from 'process';
import { AdStatus } from "./ads.service";

@Component({
  selector: 'ad-preview',
  templateUrl: './preview.html',
  styleUrls:['./preview.scss'],
})

export class AdPreview implements OnInit, OnDestroy {
    @Input() ad: any;
    @Input() onUpdate: any;
    @Input() onApprove: any;
    @Input() onReject: any;
    @Input() onFlag: any;
    @Input() onClose: any;

    private currentSlide: number = 0;
    private totalSlides: number = 0;
    private sliderInterval: any  = null;
    public AdStatus = AdStatus;

    public deviceText: IMultiSelectTexts = {
        defaultTitle: 'Devices'
      }

    public mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'fontawesome',
    buttonClasses: 'btn btn-default btn-block multiple-dropdown',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    fixedTitle: true,
    showCheckAll: true,
    showUncheckAll: true
    }
    public device_ids: Array<Number>;
    public devices: Array<IMultiSelectOption>;
    public ad_spent_net: Number;
    public cpv_gross: Number;

    public activePreview: any;
    private currentTarget: number = 0;
    private totalTargets: number = 0;
    public adType: number = 0;

    constructor() {
        this.device_ids = []
        this.devices = []
        this.ad_spent_net = 0
        this.cpv_gross = 0
    }

    onChange() {
        this.ad.approveddevices = this.device_ids
        this.ad.ad_spent_net = this.ad_spent_net
        this.ad.cpv_gross = this.cpv_gross
    }

    ngOnInit() {
        if (this.ad.Files.length == 0 && this.ad.target_preview.length == 0) {
            alert("Bad ad without files =(");
            console.log("Bad ad without files =(");
            this.onClose();
            return;
        }
        if (this.ad.devices != null){
            this.ad.devices.forEach(element => {
                this.devices.push({id:element,name:element})
            });
        }
        this.ad.approveddevices = [];
        this.ad_spent_net = this.ad.ad_spent_net;
        this.cpv_gross = this.ad.cpv_gross;

        this.totalTargets = this.ad.target_preview.length;
        this.preparePreview();
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide+1)%this.totalSlides;
    }

    ngOnDestroy() {
        if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
        }
    }

    nextPreview() {
        if (this.currentTarget + 1 < this.totalTargets) {
            this.currentTarget++;
            this.preparePreview();
        }
    }

    prevPreview() {
        if (this.currentTarget - 1 >= 0) {
            this.currentTarget--;
            this.preparePreview();
        }
    }

    preparePreview() {
        this.activePreview = this.ad.target_preview[this.currentTarget];

        if (this.sliderInterval) {
            clearInterval(this.sliderInterval);
        }

        this.currentSlide = 0;

        if (this.activePreview.Files[0].type === undefined || this.activePreview.Files[0].type == 0) {
            this.adType = this.ad.type;
        } else {
            this.adType = this.activePreview.Files[0].type;
        }

        if (this.adType == 2) {
            this.totalSlides = this.activePreview.Files.length;
            this.sliderInterval = setInterval(() => {
                this.nextSlide();
            }, 2000);
        }
    }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/approval/preview.ts